export const headers = {
    'content-type': "application/json",
    "Accept": "application/json, text/plain, */*",
};

export const baseUrl = "https://pontisacadexusedu.com";
export const baseUrl_1 = "https://pontisacadexusedu.com/";
export const up_baseUrl_1 = "https://efeb-2404-bd00-4-b000-00-f6.ngrok-free.app";